module.exports = __webpack_public_path__ + "static/media/MHRP52N0002.4d31173d.svg";